let defaultCarrierColumns = [
  'AccountID', 'Company', 'Connote', 'Date', 'Ref',
  'No Items', 'Weight (Kg)', 'Cube (m3)',
  'Sender Name', 'Sender Address 1', 'Sender Address 2', 'Sender Town', 'Sender State', 'Sender Postcode', 'Sender Contact', 'Sender Phone', 'Sender Email',
  'Receiver Name', 'Receiver Address 1', 'Receiver Address 2', 'Receiver Town', 'Receiver State', 'Receiver Postcode', 'Receiver Contact', 'Receiver Town', 'Receiver Phone', 'Receiver Email',
  'Special Instructions', 'Chep Pallets', 'Loscam Pallets', 'Other Pallets',
  'DG', 'Cost Centre', '3rd Party Account', 'Zone From', 'Zone To', 'Carrier', 'Service',
  'Freight', 'Fuel', 'Security', 'Surcharge', 'Gst', 'Total'
]

export default class Configs {
  /**
     * Configuration for Gibson
     */
  static gibson () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          name: 'Company',
          conno: 'Connote',
          date: 'Date',
          refno: 'Ref',
          items: 'No Items',
          weight: 'Weight (Kg)',
          volume: 'Cube (m3)',
          sender: 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          receiv2: 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          amount: 'Freight'
          // 'Fuel',
          // 'Gst',
          // 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          // 'Zone From',
          // 'Zone To',
          // 'Carrier',
          // 'Service'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'D-MMM-YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'explode',
        params: {
          by: '-',
          from: 'route',
          to: ['Zone From', 'Zone To']
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['No Items', 'Weight (Kg)', 'Cube (m3)', 'Freight']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Fuel', 'FUEL']
        }
      }
    ]
  }
  /**
     * Configuration for GKR transport
     */
  static gkrtransport () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          name: 'Company',
          conno: 'Connote',
          date: 'Date',
          refno: 'Ref',
          items: 'No Items',
          weight: 'Weight (Kg)',
          volume: 'Cube (m3)',
          sender: 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          receiv2: 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          // 'Freight'
          // 'Fuel',
          // 'Gst',
          amount: 'Total'
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          // 'Zone From',
          // 'Zone To',
          // 'Carrier',
          // 'Service'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'D-MMM-YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'explode',
        params: {
          by: '-',
          from: 'route',
          to: ['Zone From', 'Zone To']
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['No Items', 'Weight (Kg)', 'Cube (m3)', 'Freight']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Fuel', 'FUEL']
        }
      }
    ]
  }

  /**
    * Configuration for Rossfreight
    */
  static rossfreight () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          // 'Company',
          CON_NOTE_NUMBER: 'Connote',
          DESPATCH_DATE: 'Date',
          CUST_REFERENCE: 'Ref',
          QUANTITY: 'No Items',
          CALC_WT: 'Weight (Kg)',
          CUBIC: 'Cube (m3)',
          EX_NAME: 'Sender Name',
          EX_ADRS1: 'Sender Address 1',
          EX_ADRS2: 'Sender Address 2',
          EX_LOCATION_NAME: 'Sender Town',
          // 'Sender State',
          EX_LOCATION_PCODE: 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          RECEIVERS_NAME: 'Receiver Name',
          RECEIVERS_ADRS1: 'Receiver Address 1',
          RECEIVERS_ADRS2: 'Receiver Address 2',
          TO_LOCATION_NAME: 'Receiver Town',
          // 'Receiver State',
          TO_LOCATION_PCODE: 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          SPECIAL_INSTRUCTIONS: 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          CHARGE: 'Freight',
          // 'Fuel',
          // 'Gst',
          // 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          EX_LOCATION_CODE: 'Zone From',
          TO_LOCATION_CODE: 'Zone To'
          // 'Carrier',
          // 'Service'
        }
      }
    ]
  }

  /**
    * Configuration for Bluestar
    */
  static bluestar () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          name: 'Company',
          conno: 'Connote',
          date: 'Date',
          refno: 'Ref',
          items: 'No Items',
          weight: 'Weight (Kg)',
          volume: 'Cube (m3)',
          sender: 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          receiv2: 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          amount: 'Freight'
          // 'Fuel',
          // 'Gst',
          // 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          // 'Zone From',
          // 'Zone To',
          // 'Carrier',
          // 'Service'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'D-MMM-YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'explode',
        params: {
          by: '-',
          from: 'route',
          to: ['Zone From', 'Zone To']
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['No Items', 'Weight (Kg)', 'Cube (m3)', 'Freight']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Fuel', 'FUEL']
        }
      }
    ]
  }

  /**
    * Configuration for startrack (aae)
    */
  static startrackaae () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          // 'Company',
          'Consignment Note Number': 'Connote',
          'Lodgement Date': 'Date',
          Reference: 'Ref',
          Quantity: 'No Items',
          'Entry Weight': 'Weight (Kg)',
          // volume: 'Cube (m3)',
          Sender: 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          Receiver: 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Total Charge GST Exclusive': 'Freight',
          // 'Fuel',
          // 'Gst',
          // 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          From: 'Zone From',
          To: 'Zone To',
          // 'Carrier',
          'Service Type': 'Service',
          'User Amt 2': 'Weight2',
          'Cubed Weight': 'Weight3'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD-MMM-YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'removeAppendedChars',
        params: {
          column: 'Connote',
          values: ['C']
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'EXS': 'AAEXS', 'EXP': 'AAEXP', 'ASK': 'AAASK' }
        }
      },
      // {
      //     action: 'moveRowValues',
      //     params: {
      //         from: ['Sender Name'],
      //         to: ['Connote'],
      //         trigger: {row: 'Service', val: 'ADA'}
      //     }
      // },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['Weight2', 'Weight3', 'Freight'],
          largestOnlyFields: ['Weight2', 'Weight3']
        }
      },
      {
        action: 'greaterOfRows',
        params: {
          column: 'Weight (Kg)',
          values: ['Weight (Kg)', 'Weight2', 'Weight3']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Sender Name',
          removePartial: false,
          values: ['Fuel Surcharge', 'Security Surcharge', 'CREDIT NOTE']
        }
      }
    ]
  }

  /**
    * Configuration for startrack (aae)
    */
  static startrack () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          // 'Company',
          'Connote Number': 'Connote',
          'Despatch date': 'Date',
          'Reference 8': 'Ref',
          'Items Connote': 'No Items',
          'Charge Weight': 'Weight (Kg)',
          'Cube': 'Cube (m3)',
          'Senders Name': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Name 2': 'Receiver Name',
          'Receiver Name 1': 'Receiver Name 2',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Cost': 'Freight',
          'Fuel Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Charge': 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'From Zone': 'Zone From',
          'To Zone': 'Zone To',
          // 'Carrier',
          'Service Type': 'Service2',
          'Security Surcharge': 'Fuel2'
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Connote',
          removePartial: true,
          values: ['_']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Connote',
          removePartial: false,
          values: ['GST ROUNDING', null, 'Manual Connote Charge']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Service2',
          removePartial: false,
          values: ['CRN']
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DDMMYYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'removePrependedChars',
        params: {
          column: 'Connote',
          values: [' ']
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'Connote',
          replace: { 'Second Delivery Charge ': 'A' }
        }
      },
      {
        action: 'mergeColumns',
        params: {
          to: 'Fuel',
          columns: ['Fuel', 'Fuel2']
        }
      },
      {
        action: 'moveRowValues',
        params: {
          from: ['Receiver Name 2'],
          to: ['Receiver Name'],
          trigger: { row: 'Receiver Name', val: null }
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['Weight (Kg)', 'No Items', 'Cube (m3)', 'Freight', 'Fuel', 'Gst', 'Total']
        }
      },
      {
        action: 'removeColumns',
        params: {
          columns: ['Service2', 'Fuel2', 'Receiver Name 2']
        }
      }
    ]
  }

  /**
    * Configuration for startrack national
    */
  static startracknational () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          // 'Company',
          'Connote Number': 'Connote',
          'Despatch date': 'Date',
          'Reference 8': 'Ref',
          'Items Connote': 'No Items',
          'Charge Weight': 'Weight (Kg)',
          'Cube': 'Cube (m3)',
          'Senders Name': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Name 2': 'Receiver Name',
          'Receiver Name 1': 'Receiver Name 2',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Cost': 'Freight',
          'Fuel Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Charge': 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'From Zone': 'Zone From',
          'To Zone': 'Zone To',
          // 'Carrier',
          'Service Type': 'Service2',
          'Security Surcharge': 'Fuel2'
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Connote',
          removePartial: true,
          values: ['_']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Connote',
          removePartial: false,
          values: ['GST ROUNDING', null, 'Manual Connote Charge']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Service2',
          removePartial: false,
          values: ['CRN']
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DDMMYYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'removePrependedChars',
        params: {
          column: 'Connote',
          values: [' ']
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'Connote',
          replace: { 'Second Delivery Charge ': 'A' }
        }
      },
      {
        action: 'mergeColumns',
        params: {
          to: 'Fuel',
          columns: ['Fuel', 'Fuel2']
        }
      },
      {
        action: 'moveRowValues',
        params: {
          from: ['Receiver Name 2'],
          to: ['Receiver Name'],
          trigger: { row: 'Receiver Name', val: null }
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['Weight (Kg)', 'No Items', 'Cube (m3)', 'Freight', 'Fuel', 'Gst', 'Total']
        }
      },
      {
        action: 'removeColumns',
        params: {
          columns: ['Service2', 'Fuel2', 'Receiver Name 2']
        }
      }
    ]
  }

  /**
     * Configuration for Toll Priority
     */
  static tollpriority () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          ACCNAME: 'Company',
          CONNOTE: 'Connote',
          ITEMDATE: 'Date',
          CUSTREF: 'Ref',
          ITEMS: 'No Items',
          WEIGHT: 'Weight (Kg)',
          // 'Cube (m3)',
          SENDER: 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          // 'Sender Town',
          //  'Sender State',
          // 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          RECEIVER: 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          // 'Receiver Town',
          // 'Receiver State',
          // 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          FREIGHTAMT: 'Freight',
          SURCHFUEL: 'Fuel',
          SURCHSECURITY: 'Security',
          SURCHAREA: 'Surcharge',
          GSTAMT: 'Gst',
          LINETOTAL: 'Total',
          // 'Other Pallets',
          // 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          SRCZONE: 'Zone From',
          DESTZONE: 'Zone To',
          // 'Carrier',
          PRODCODE: 'Service',
          SURCHAREB: 'Surcharge2'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'D/M/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'Ref',
          replace: { 'Excess wt on con ': '', '*': '' }
        }
      },
      {
        action: 'moveRowValues',
        params: {
          from: ['Ref'],
          to: ['Connote'],
          triggerPartial: true,
          trigger: { row: 'Connote', val: 'PREP' }
        }
      },
      {
        action: 'mergeColumns',
        params: {
          to: 'Surcharge',
          columns: ['Surcharge', 'Surcharge2']
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Connote',
          removePartial: false,
          values: [null]
        }
      },
      {
        action: 'mergeRows',
        params: {
          by: 'Connote',
          fields: ['Freight', 'Fuel', 'Security', 'Surcharge', 'Gst', 'Total']
        }
      },
      {
        action: 'removeColumns',
        params: {
          columns: ['Surcharge2']
        }
      }
    ]
  }

  /**
    * Configuration for TNT EXPRESS
    */
  static tntexpress () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 73': 'TNTSAT', 'D 75': 'TNTONFC', 'D 75C': 'TNTONF', 'D 76': 'TNTROAD', 'D 76C': 'TNTROA', 'D 712': 'TNT9AM', 'D 717B': 'TNTSPEC', 'D 717': 'TNTSPEC2', 'D EX10': 'TNT10AM', 'D EX12': 'TNT12PM' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
    * Configuration for TNT NATIONAL
    */
  static tntnational () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 75': 'TNTONFCN', 'D 76': 'TNTROADN' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
    * Configuration for TNT (VIC)
    */
  static tntvic () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 75': 'TNTVO', 'D 76': 'TNTV' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
    * Configuration for TNT (SA)
    */
  static tntsa () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 75': 'TNTSO', 'D 76': 'TNTS' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
    * Configuration for TNT (QLD)
    */
  static tntqld () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 75': 'TNTQO', 'D 76': 'TNTQ' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
    * Configuration for TNT (NSW)
    */
  static tntnsw () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          'Invoice Child Account Name': 'Company',
          'Consignment No': 'Connote',
          'Pick Up Date': 'Date',
          'Reference': 'Ref',
          'Total Pieces': 'No Items',
          'Billed Weight': 'Weight (Kg)',
          'Volume': 'Cube (m3)',
          'Sender Company': 'Sender Name',
          // 'Sender Address 1',
          // 'Sender Address 2',
          'Sender City': 'Sender Town',
          //  'Sender State',
          'Sender Postcode': 'Sender Postcode',
          // 'Sender Contact',
          // 'Sender Phone',
          // 'Sender Email',
          'Receiver Company': 'Receiver Name',
          // 'Receiver Name',
          // 'Receiver Address 1',
          // 'Receiver Address 2',
          'Receiver City': 'Receiver Town',
          // 'Receiver State',
          'Receiver Postcode': 'Receiver Postcode',
          // 'Receiver Contact',
          // 'Receiver Town',
          // 'Receiver Email',
          // 'Special Instructions',
          // 'Chep Pallets',
          // 'Loscam Pallets',
          'Freight Amount': 'Freight',
          'Surcharge': 'Fuel',
          'GST': 'Gst',
          'Total Amount': 'Total',
          // 'Other Pallets',
          'Dangerous Goods': 'DG',
          // 'Cost Centre',
          // '3rd Party Account',
          'Origin': 'Zone From',
          'Destination': 'Zone To',
          // 'Carrier',
          'Div/Prod Code': 'Service',
          'Invoice Child Account Number': 'Charge Account'
        }
      },
      {
        action: 'formatDate',
        params: {
          column: 'Date',
          from: 'DD/MM/YYYY',
          to: 'DD/MM/YYYY'
        }
      },
      {
        action: 'mapServices',
        params: {
          column: 'Service',
          mapping: { 'D 75': 'TNTNONFC', 'D 76': 'TNTN', 'D 712': 'TNTN9AM' }
        }
      },
      {
        action: 'replaceText',
        params: {
          column: 'DG',
          replace: { 'N': '0', 'Y': '1' }
        }
      },
      {
        action: 'removeRows',
        params: {
          column: 'Ref',
          removePartial: false,
          values: ['Debit Adjustment']
        }
      }
    ]
  }

  /**
     * Configuration for Toll
     */
  static toll () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: defaultCarrierColumns
        }
      },
      {
        action: 'map',
        params: {
          // 'Billing_Grp',
          'BU': 'Service',
          // 'Cust_No',
          // 'Name',
          // 'week',
          // 'Statement#',
          'Date': 'Date',
          // 'Manifest',
          'Connote #': 'Connote',
          // 'Trn',
          // 'Sender Doc#',
          'Sender': 'Sender Name',
          'Senders Suburb': 'Sender Town',
          // 'Sender Ref#',
          'Receiver': 'Receiver Name',
          // 'Receivers Ref#',
          'From': 'Zone From',
          'To': 'Zone To',
          'Rec Suburb': 'Receiver Town',
          'Service': 'Service',
          // 'Mode',
          // 'Descr of goods',
          'Tot Items': 'No Items',
          // 'Tot Pallets',
          // 'Tot Misc',
          'm3': 'Cube (m3)',
          'Weight': 'Weight (Kg)',
          // 'Charge Weight',
          'Charge': 'Freight',
          'GST': 'Gst',
          'Total Charge': 'Total'
          // 'Charge for: 1',
          // 'Charge for: CITYLINK',
          // 'Charge for: CON',
          // 'Charge for: DG',
          // 'Charge for: FRLABL',
          // 'Charge for: FRT',
          // 'Charge for: GST',
          // 'Charge for: MANCN',
          // 'Charge for: MIN',
          // 'Charge for: ONFCON',
          // 'Charge for: ONFFRT',
          // 'Charge for: ONFMIN',
          // 'Charge for: TAILGATE',
          // 'Charge for: TNQXFSC',
          // 'Purchase Orders...'
        }
      }
    ]
  }

  /**
     * Configuration for Address Book
     */
  static addressbook () {
    return [
      {
        action: 'defaultColumns',
        params: {
          columns: ['code', 'name', 'line_one', 'line_two', 'suburb', 'postcode', 'state', 'contact', 'phone', 'email', 'spi', 'rtp_account']
        }
      },
      {
        action: 'map',
        params: {
          'CUSTOMER CODE': 'code',
          'COMPANY NAME': 'name',
          'ADDRESS1': 'line_one',
          'ADDRESS2': 'line_two',
          'SUBURB': 'suburb',
          'POSTCODE': 'postcode',
          'STATE': 'state',
          'CONTACT NAME': 'contact',
          'PHONE': 'phone',
          'EMAIL': 'email',
          'SPECIAL': 'spi'
        }
      }
    ]
  }
}
